<div class="app-ocr-quick-fix-sidebar">
  <div class="app-ocr-quick-fix-sidebar__sidebar">
    <div class="app-ocr-quick-fix-sidebar__header">
      <p class="app-ocr-quick-fix-sidebar__header__title">{{ sidebarTitle | translate }}</p>
      <div
        nz-tooltip
        nzTooltipColor="#ffffff"
        nzTooltipPlacement="top"
        nzTooltipOverlayClassName="normalize"
        [nzTooltipTitle]="'BUTTON.PREVIEW' | translate"
        [ngClass]="{ disabled: !previewModalDocs?.length }"
        class="app-ocr-quick-fix-sidebar__header__preview-document-button"
      >
        <img src="assets/icons/icon_eye_gray_sm.svg" alt="preview doc" (click)="onPreviewDocument()" />
      </div>
    </div>

    <div class="app-ocr-quick-fix-sidebar__body">
      <div class="app-ocr-quick-fix-sidebar__progress-bar">
        <div class="app-ocr-quick-fix-sidebar__progress-bar__line">
          <div class="app-ocr-quick-fix-sidebar__progress-bar__bar" [style.width]="currentStepProgress"></div>
        </div>
      </div>

      <div class="app-ocr-quick-fix-sidebar__form">
        <div #stepForm></div>
      </div>
    </div>

    <div class="app-ocr-quick-fix-sidebar__footer">
      <button [disabled]="isFirstStep" type="button" class="btn btn-lg btn-outline-bordered btn-square" (click)="onBack()">
        {{ "BUTTON.BACK" | translate }}
      </button>

      <button type="button" class="btn btn-lg btn-square btn-primary" (click)="onNext()">
        {{ nextButtonText | translate }}

        <img src="assets/icons/icon_arrow_right_sm_white.svg" alt="arrow right" />
      </button>
    </div>
  </div>

  <div *ngIf="isOpenDocsPreviewModal" class="app-ocr-quick-fix-sidebar__document-preview">
    <app-document-preview-box
      [index]="currentPreviewModalDocIndex"
      [previewDocs]="previewModalDocs"
      [open]="isOpenDocsPreviewModal"
      (delete)="onPreviewDocumentDelete($event)"
      (close)="onCloseDocumentPreview()"
    ></app-document-preview-box>
  </div>
</div>
